import { DateTime } from 'luxon';
import { createJSONStorage, type StateStorage } from 'zustand/middleware';

const isoDateRegex =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:[+-]\d{2}:\d{2}|Z)?$/;

const jsonReviver = (_key: string, value: unknown): unknown => {
  if (typeof value === 'string' && isoDateRegex.test(value)) {
    const parsed = DateTime.fromISO(value).toLocal();
    return parsed.isValid ? parsed : value;
  }

  return value;
};

const noopStorage: StateStorage = {
  getItem: async () => null,
  setItem: async () => {},
  removeItem: async () => {},
};

export const createPersistStorage = <T>() =>
  createJSONStorage<T>(
    () => (typeof window === 'undefined' ? noopStorage : window.localStorage),
    {
      reviver: jsonReviver,
    },
  )!;

